import React from 'react';
import { connect } from 'react-redux';

import Header from './Header/Header';
import Main from './Main';
import Notify from 'components/ui/Notify';
import FileDownload from 'components/ui/FileDownload';
import { actions as profileActions } from 'features/Settings/profile/store/actions';
import AuthService from 'core/utils/auth/auth-service';

class LoggedIn extends React.Component {
  componentWillMount() {
    let profile = AuthService.getProfile();
    this.props.dispatch(profileActions.fetchSuccess(profile));
  }

  render() {
    return (
      <div>
        <Header />
        <Main />
        <Notify />
        <FileDownload />
      </div>
    );
  }
}

export default connect()(LoggedIn);



// WEBPACK FOOTER //
// ./src/components/layouts/LoggedIn/index.jsx